import { Grid, Typography } from "@mui/material";
import { DeviceHub } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DevicesStats from "../DevicesStats/DevicesStats.component";
import { useStats } from "../../../../providers/StatsProvider/StatsProvider";
import LoadingNotification from "../../../UI/LoadingNotification/LoadingNotification.component";
import {
  WarningNotification,
  ErrorNotification,
} from "../../../UI/Notifications";

const DevicesCard: React.FC = () => {
  const { loading, errorMessage, stats } = useStats();
  const { t } = useTranslation();

  if (loading) {
    return <LoadingNotification label={t("common.loading")} />;
  }

  if (errorMessage) {
    return <ErrorNotification title={errorMessage} />;
  }

  if (!stats) {
    return <WarningNotification title={t("messages.notFound")} />;
  }

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item xs={12} md={4}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <DeviceHub sx={{ fontSize: 72 }} />

          <Typography variant="h5">
            <Link to="/devices" style={{ textDecoration: "none" }}>
              {t("dashboard.stats.devices.title")}
            </Link>
          </Typography>
          <Typography variant="h5">
            {t("dashboard.stats.total", {
              total: stats?.devices.all || 0,
            })}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8} sx={{ minHeight: "190px" }}>
        <DevicesStats />
      </Grid>
    </Grid>
  );
};

export default DevicesCard;
